module.exports = __webpack_public_path__ + "img/icon_success.ca011d46.svg";